import { styled } from 'styled-components'
import { onLargeScreen } from 'mixtiles-web-common'

export const HeaderContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`

export const ErrorMessageContainer = styled.div`
  margin: 0 25px;
`

export const FormContainer = styled.div`
  margin-top: 82px;

  ${onLargeScreen()} {
    margin-top: 99px;
  }
`
